import FlashLib from "flashlib";
import {TweenMax, Back} from "gsap";
import EntryPoint from "Engine/EntryPoint";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import GameModel from "../model/GameModel";
import MoneyFormat from "Base/MoneyFormat";
import SoundManager from "Engine/soundManager/SoundManager";

export default class FreeSpinsWindowContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.valueText = null;

        this.init();
        this.addListeners();
        this.createTweens();
        this.hide();
    }

    init() {
        

    }

    addListeners() {
        EntryPoint.Game.app.stage.on('pointertap', this.onClick, this);
    }

    changeState(value) {
        this.goToFrame(value);
        if (value === 2) {
            this.valueText = this.getChildByName('valueText');
        } else {
            this.valueText = null;
        }
    }

    onClick(event) {
        if (event.target === event.currentTarget) {
            GlobalDispatcher.dispatch('freeSpinsWindow:close');
            this.hide();
        }
    }

    createTweens() {
        this.showTween = TweenMax.fromTo(this.scale, 0.5, {x: 0, y: 0}, {x: 1, y: 1, ease: Back.easeOut, paused: true});
    }

    show(value) {
        this.changeState(value);
        EntryPoint.Game.app.stage.interactive = true;
        this.showTween.play(0);
        this.visible = true;

        let soundName = value === 1 ? 'FreeSpinsIn' : 'FreeSpinsOut';
        SoundManager.play('sounds/mainGame/' + soundName, 1, false);

        if (this.valueText && !this.valueText._destroyed) {
            this.valueText.text = MoneyFormat.format(GameModel.freeSpins.totalWin);
        }
    }

    hide() {
        EntryPoint.Game.app.stage.interactive = false;
        this.visible = false;
    }
}